// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-ghost[data-v-136504fa],\r\n.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-chosen[data-v-136504fa] {\r\n  background-color: #dfecfb;\n}\n.column-sortable-grid .vxe-header--row .vxe-header--column.col--fixed[data-v-136504fa] {\r\n  cursor: no-drop;\n}\r\n", ""]);
// Exports
module.exports = exports;
